<template>
	<div class='empty-wrap' :style="{'padding': padding}">
		<img src="@/static/images/empty.png" alt="">
		<p>{{emptyText}}</p>
	</div>
</template>

<script>

export default {
	name: 'empty',
	props: {
		emptyText: {
			type: String,
			default: '暂无数据'
		},
		padding: {
			type: String,
			default: '100px 0'
		}
	}
}
</script>
<style lang='scss' scoped>
	.empty-wrap {
		width: 100%;
		padding: 100px 0;
        background-color: #fff;
		& > img {
			width: 190px;
			height: 160px;
			display: block;
			margin: 0 auto;
		}
		& > p {
			font-size: 15px;
			color: #a7a8a8;
			text-align: center;
		}
	}
</style>